import styles from '../../styles/HowItWorksPageStep.module.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons";
import Image from "next/image";
import { RichText } from '../RichText';

const HowItWorksPageStep = (props: {
  title: string,
  description: string,
  imagePosition: 'left' | 'right',
  image: string,
  variant: 'default' | 'special',
  showArrowBelow: boolean
}) => {
  return(
    <>
      <div className={[styles.container, 'd-flex gap-2', (props.imagePosition === 'right' ? 'flex-column flex-lg-row' : 'flex-column flex-lg-row-reverse')].join(' ')}>
        <div className={styles.textContainer}>
          <div className={[styles.text, styles[props.variant]].join(' ')}>
            {props.title && <h4 className='mb-3'>{props.title}</h4>}
            {props.description && <RichText content={props.description} className={styles.description} />}
          </div>
        </div>
        <div className={styles.image}>
          <Image src={props.image} className='img-fluid' alt={props.title} width={494} height={494}/>
        </div>
      </div>
      {props.showArrowBelow && (
        <div className={styles.arrow}>
          <FontAwesomeIcon icon={faArrowDown} />
        </div>
      )}
    </>
  )
}

export default HowItWorksPageStep
